export default "__VITE_ASSET__DOBmSD42__"